
export const ENDPOINTS = {

    // user endpoints

    USER_LOGIN: `/login`,
    // VERIFY: `/user/verify`,
    UPDATE_USER_PROFILE: `customer/update-user`,
    USER_DELETE: `/customer/deactive-user`,
}